import React from 'react';
import StatisticParameter from '../StatisticParameter/index.troy';

import { CUSTOMER_MESSAGE_TYPES } from '../../../constants/post-box';

const StatisticFilter = ({
  styles,
  onTypeChange,
  chosenStatisticFilter,
  groups,
}) => {
  return CUSTOMER_MESSAGE_TYPES.map(({ label, types, id }, key) => (
    <StatisticParameter
      label={label}
      id={id}
      chosen={chosenStatisticFilter === types}
      key={key}
      count={
        types
          ? types.map((type) => groups[type]).reduce((a, b) => a + b, 0)
          : groups['summ']
      }
      onClick={() => onTypeChange(types)}
    />
  ));
};

export default StatisticFilter;
